'use client';

// Portuguese copy of components/supportedPlatforms (PT-1). Fallback when a
// hub has no platform carousel tiles.

import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import Link from 'next/link';
import React from 'react';
import { CSSProperties } from 'styled-components';
import { CustomLink } from '../link/link.comp';
import {
    DEFAULT_PLATFORM_TILES,
    IPlatformTile,
} from '../widgetPlatformCarousel/widgetPlatformCarousel.data';
import { EnTag } from './langSwitch.comp';
import { StyledDiv } from '../supportedPlatforms/supportedPlatforms.styles';

export const SupportedPlatformsPt = ({ style = {} }: { style?: CSSProperties; }) => {
    const renderTile = (p: IPlatformTile) => (
        <Link
            key={p.slug}
            href={`/platforms/${p.slug}`}
            className="tile"
            aria-label={`Plataforma ${p.name} (em inglês)`}
            hrefLang="en"
            title={p.name}
        >
            <svg
                className="icon"
                role="img"
                viewBox="0 0 24 24"
                width="44"
                height="44"
                fill={`#${p.iconHex}`}
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
            >
                <path d={p.iconPath} />
            </svg>
        </Link>
    );

    return (
        <StyledDiv style={style}>
            <h2>Compatível com todos os criadores de sites, plataformas de e-commerce e sites</h2>
            <div className="companies-wrapper">
                {DEFAULT_PLATFORM_TILES.map(renderTile)}
            </div>
            <CustomLink className='show-more' href='/platforms' title='Ver todas as plataformas compatíveis'>Ver todas as plataformas compatíveis <EnTag />
                <IoIosArrowForward className='icon' />
            </CustomLink>
        </StyledDiv>
    );
};
